import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, ViewChild, ElementRef, Renderer } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import { GridOptions } from 'ag-grid';
import { OnDemandDriversService } from '../../on-demand-drivers.service';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { constant } from '../../../../app.constants';
import {LicensesService} from '../../../../services/licenses.service';

@Component({
  selector: 'app-on-demand-drivers-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit, OnChanges {

  public tabFiles = 1;

  @Input() selected: number;
  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() cancel: EventEmitter < boolean > = new EventEmitter < boolean > ();

  @ViewChild('attachment') attachmentBtn: ElementRef;
  @ViewChild('licenseBtn') licenseBtn: ElementRef;

  @ViewChild('popDocumentsContent') cardDocuments: T2CardComponent;
  @ViewChild('popLicenseContent') cardLicense: T2CardComponent;

  private documentGrid: GridOptions;
  private licenseGrid: GridOptions;

  /**
   * variable for licenses
   */
  private showInactive = false;
  private selectedLicenseType: number;
  private licenseTypes: any[];
  public maskDate = constant.MASKS.DATES.DDMMYYYY;
  private thePattern = '';


  /**
    Variables for upload data
   */
  private isMsgVisible = false;
  private b64File: string;
  private strSubstr: string;
  private str: string;
  private base64File: string;
  private description = null;
  private documentFile: any;
  private fileName: string;
  private mimeType: string;
  private readHistoryFilesValue: any;
  private uploadHistoryEvent: any;
  private showLoading = false;
  private errorMessage = null;

  constructor(protected service: OnDemandDriversService, private renderer: Renderer, protected onDemandService: OnDemandDriversService,
              private _serviceLicensesService: LicensesService) {
    this.documentGrid = < GridOptions > {};
    this.configureGrid();
    this.licenseGrid = < GridOptions > {};
    this.configureLicenceGrid();
  }

  ngOnInit() {
    if (this.selected !== 0) {
      this.onDemandService.getDriverByID(this.selected).subscribe(
        data => {
          this.getLicenseTypes(data.companyid);
        }
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const selectedChange = changes['selected'];

    if (
      selectedChange &&
      !selectedChange.isFirstChange() &&
      selectedChange.currentValue &&
      selectedChange.currentValue !== selectedChange.previousValue
    ) {
      if (this.selected !== 0) {
        this.onDemandService.getDriverByID(this.selected).subscribe(
          data => {
            this.getLicenseTypes(data.companyid);
          }
        );
      }
      if (this.documentGrid && this.documentGrid.api) {
        this.documentGrid.api.setRowData([]);
      }
      this.getDocuments();
    }
  }

  public cancelCreateEdit() {
    this.cancel.emit(true);
  }

  private getDocuments() {
    this.service
      .getDocuments(this.selected)
      .subscribe(
        data => {
          if (this.documentGrid) {
            if (this.documentGrid.api) {
              this.documentGrid.api.setRowData(data);
            }
          }
        }

      );
  }

  private configureGrid() {
    const self = this;
    this.documentGrid.columnDefs = [{
        headerName: 'Added On',
        field: 'addedonformatted',
        colId: 'addedonformatted'
      },
      {
        headerName: 'Document',
        field: 'description',
        colId: 'description'
      },
      {
        headerName: 'Image',
        field: 'attachment',
        // cellRendererFramework: ViewAttachment,
        colId: 'attachment'
      }
    ];

    this.documentGrid.onGridReady = function () {
      self.getDocuments();
      self.documentGrid.api.sizeColumnsToFit();
    };
  }

  public onPanelChange(options) {
    this.resetView();
    this.tabFiles = options;
    if (options === 1) {
      this.getDocuments();
    } else {
      this.getLicenses();
    }
  }

  /**
   * METHODS TO UPLOAD DOCUMENT
   */
  public uploadHistoryFile(event) {
    if (event.target.files.length) {
      this.isMsgVisible = false;
      this.readHistoryFilesValue = event.target.files[0];
      this.uploadHistoryEvent = event;
      this.readFiles(this.readHistoryFilesValue);
      this.fileName = this.readHistoryFilesValue.name;
      this.mimeType = this.readHistoryFilesValue.type;
      this.errorMessage = null;
    } else {
      this.fileName = '';
    }
  }

  private readFiles(files) {
    if (files) {
      const reader = new FileReader();
      this.readFile(files, reader, (result) => {
        // this.historyFileSelected=result;
      });
    }
  }

  private readFile(file, reader, callback) {
    if (file) {
      reader.onload = () => {
        callback(reader.result);
        this.base64File = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  public saveDocument(): void {
    if (this.base64File != null && this.base64File && this.description != null && this.description !== '') {
      this.cardDocuments.viewProgressBar(true);
      this.errorMessage = null;
      this.showLoading = true;

      this.isMsgVisible = false;
      this.str = this.base64File;
      this.strSubstr = this.str.substr(0, this.str.lastIndexOf(','));
      this.b64File = this.base64File.replace(this.strSubstr + ',', '');
      this.documentFile = {
        'trip2driverid': this.selected,
        'imagebase64': this.b64File,
        'description': this.description,
        'mimetype': this.mimeType
      };

      this.service
      .addDocument(this.documentFile)
      .finally(() => {
        this.showLoading = false;
        this.cardDocuments.viewProgressBar(true);
      })
      .subscribe(
        data => {
          this.getDocuments();
          this.resetView();
          this.cardDocuments.close();
        },
        err => {
          this.errorMessage = 'Error, please try later';
        }
      );
    } else {
      this.isMsgVisible = true;
      this.errorMessage = 'File is required';
    }
  }


  private resetView() {
    this.base64File = null;
    this.description = '';
    this.fileName = '';
    this.errorMessage = null;
    this.documentFile = {};
  }


  /**
   * ************************** LICENCES ************************
   */

  private configureLicenceGrid() {
    const self = this;
    this.licenseGrid.columnDefs = [{
        headerName: 'Added On',
        field: 'addedonformatted',
        colId: 'addedonformatted'
      },
      {
        headerName: 'Document',
        field: 'typelicenseprovider.typelicense.description',
        colId: 'description'
      },
      {
        headerName: 'Expiration',
        field: 'expirationformatted',
        colId: 'expirationformatted'
      },
      {
        headerName: 'Status',
        field: 'status',
        colId: 'status'
      },
      {
        headerName: 'Image',
        field: 'attachment',
        // cellRendererFramework: ViewAttachment,
        colId: 'attachment'
      }
    ];

    this.licenseGrid.onGridReady = function () {
      self.licenseGrid.api.sizeColumnsToFit();
      self.getLicenses();
    };
  }

  private getLicenses() {
    this.service
    .getLicenses(this.selected, this.showInactive)
    .subscribe(
      data => {
        if (this.licenseGrid) {
          if (this.licenseGrid.api) {
            this.licenseGrid.api.setRowData(data)
          }
        }
      }
    );
  }

  /**
   * Method for get licenses when show expired is checked/unchecked
   * @param event
   */
  public showExpired(event) {
    this.getLicenses();
  }

  /**
   * Retrieve license types data
   */
  private getLicenseTypes(ProviderId: number) {
    this.getTypeLicenseProvider(ProviderId);
    /*this.service
    .getLicenseTypes()
    .subscribe(
      data => this.licenseTypes = data
    );*/
  }

  getTypeLicenseProvider(ProviderId: number) {
    // this.data.companyid
    this._serviceLicensesService.getTypeLicenseDriverProviderId(ProviderId).subscribe(
      data => {
        this.licenseTypes = data;
      }
    );
  }

  /**
   * call method in service for save the license into bd
   */
  public saveLicense() {
    if (this.base64File != null && this.description != null && this.description !== '') {
      this.cardLicense.viewProgressBar(true);
      this.errorMessage = null;
      this.showLoading = true;

      this.isMsgVisible = false;
      this.str = this.base64File;
      this.strSubstr = this.str.substr(0, this.str.lastIndexOf(','));
      this.b64File = this.base64File.replace(this.strSubstr + ',', '');
      this.documentFile = {
        'trip2driverid': this.selected,
        'TypeLicenseProviderId': this.selectedLicenseType,
        'Expiration': this.description,
        'imagebase64': this.b64File,
        'mimetype': this.mimeType
      };

      this.service
      .addLicense(this.documentFile)
      .finally(() => {
        this.showLoading = false;
        this.cardLicense.viewProgressBar(false);
      })
      .subscribe(
        data => {
          this.getLicenses();
          this.resetView();
          this.cardLicense.close();
        },
        err => {
          this.errorMessage = 'Error, please try later';
        }
      );
    } else {
      this.isMsgVisible = true;
      this.errorMessage = 'File is required';
    }
  }

  public onBlurDate() {
    this.thePattern = '^((0?[1-9]|1[012])[- -.](0?[1-9]|[12][0-9]|3[01])[- -.](19|20)?[0-9]{2})*$';
  }

  onOpenDocument($event) {
    window.open($event.data.attachment);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/documents/documents.component.ts